import axiosInstanceNew from "../lib/axiosinstanceNew";

const BannerModal = class {

    constructor(){
        this.baseUrl="banners";
    }
    async Getbanner(){
        return(
            await axiosInstanceNew.get(`${this.baseUrl}`)
        )
    }
    async Addbanner(data =[]){
        return(
            await axiosInstanceNew.post(`${this.baseUrl}`,data)
        )
    }
    async deleteBanner(id){
        return(
            await axiosInstanceNew.delete(`${this.baseUrl}/${id}`)
        )
    }
    async EditBanner(id, data=[]){
        return(
            await axiosInstanceNew.put(`${this.baseUrl}/${id}`,data)
        )
    }
}
export default new BannerModal();